"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const Legend = _ref => {
  let {
    categories = [],
    fontSize = constants_1.DEFAULT_FONT_SIZE,
    style = {},
    entryStyle = {},
    onMouseOver = () => {},
    onMouseOut = () => {},
    onClick = () => {}
  } = _ref;
  return react_1.default.createElement("div", {
    className: styles_module_css_1.default['legend-container'],
    style: style
  }, categories.map((category, i) =>
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/mouse-events-have-key-events, jsx-a11y/no-static-element-interactions
  react_1.default.createElement("div", {
    className: styles_module_css_1.default['legend-entry'],
    style: {
      ...entryStyle,
      opacity: categories ? 1 : 0.25,
      paddingBottom: fontSize > 13 ? fontSize - 13 : 0
    },
    // eslint-disable-next-line react/no-array-index-key
    key: `category-${i}`,
    onMouseOver: event => onMouseOver(event, i, category),
    onMouseOut: event => onMouseOut(event, i, category),
    onClick: event => onClick(event, i, category)
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['legend-marker'],
    style: {
      backgroundColor: colors_1.COLOR_PALETTE[category.color] || category.color || colors_1.DEFAULT_COLORS[i % colors_1.DEFAULT_COLORS.length],
      width: fontSize,
      height: fontSize
    }
  }), react_1.default.createElement("div", {
    className: styles_module_css_1.default['legend-text'],
    style: {
      color: colors_1.COLOR_PALETTE[category.color] || category.color || colors_1.DEFAULT_COLORS[i % colors_1.DEFAULT_COLORS.length],
      fontSize
    }
  }, category.label))));
};
Legend.propTypes = {
  /**
   * Color and text for each legend entry
   */
  categories: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    // id of the category
    id: prop_types_1.string.isRequired,
    // label for this category, visible
    label: prop_types_1.string.isRequired,
    // color for this category
    color: prop_types_1.string,
    // whether to be highlighted by default
    highlighted: prop_types_1.bool
  })).isRequired,
  /**
   * legend text size
   */
  fontSize: prop_types_1.number,
  /**
   * styling for the legend container
   */
  style: (0, prop_types_1.shape)(),
  /** Style for the animated wrapper */
  entryStyle: (0, prop_types_1.shape)(),
  /**
   * function to activate on mouseOver
   * parameters: (event, index, category)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, index, category)
   */
  onMouseOut: prop_types_1.func,
  /**
   * function to activate on click
   * parameters: (event, index, category)
   */
  onClick: prop_types_1.func
};
exports.default = Legend;